import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatRoutingModule } from './chat-routing.module';
import { ChatComponent } from './pages/chat/chat.component';
import { ChatSidebarComponent, HighlightPipe } from './pages/chat/components/chat-sidebar/chat-sidebar.component';
import { FormsModule } from '@angular/forms';
import { ChatQuestionComponent } from './pages/chat/components/chat-main/chat-question/chat-question.component';
import { ChatResponseComponent } from './pages/chat/components/chat-main/chat-response/chat-response.component';
import { ChatDocumentComponent } from './pages/chat/components/chat-document/chat-document.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { StyleClassModule } from 'primeng/styleclass';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { DocumentListSiderbarComponent } from './pages/chat/components/document-list-siderbar/document-list-siderbar.component';
import { TableModule } from 'primeng/table';
import { EditorModule } from 'primeng/editor';
import { SharedModule } from '@app/common/shared.module';
import { AceEditorComponent } from './pages/chat/components/chat-main/chat-response/ace-editor/ace-editor.component';
import { MarkdownModule, MARKED_OPTIONS, MarkedRenderer  } from 'ngx-markdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DialogModule } from 'primeng/dialog';
import { ChatIterationLoaderComponent } from './pages/chat/components/chat-main/chat-iteration-loader/chat-iteration-loader.component';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { EsgFiltersComponent } from './pages/chat/components/document-list-siderbar/esg-filters/esg-filters/esg-filters.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ChatMainComponent } from './pages/chat/components/chat-main/chat-main.component';
import { DocumentsDialogboxComponent } from './pages/chat/components/chat-main/documents-dialogbox/documents-dialogbox.component';
import { QecDocumentsDialogboxComponent } from './pages/chat/components/chat-main/qec-documents-dialogbox/qec-documents-dialogbox.component';
import { DocumentsModule } from '../documents/documents.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { EsgDocumentsDialogComponent } from './pages/chat/components/chat-main/esg-documents-dialog/esg-documents-dialog.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CarouselModule } from 'primeng/carousel';
import { ChatResponseTablesComponent } from './pages/chat/components/chat-main/chat-response-tables/chat-response-tables.component';
import { ChatResponseSuggestedQuestionsComponent } from './pages/chat/components/chat-main/chat-response-suggested-questions/chat-response-suggested-questions.component';
import { ChatResponseLoaderComponent } from './pages/chat/components/chat-main/chat-response/chat-response-loader/chat-response-loader.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { ChatHeroSuggestedQuestionsComponent } from './pages/chat/components/chat-main/chat-hero-suggested-questions/chat-hero-suggested-questions.component';
import { ChatResponseTableChartComponent } from './pages/chat/components/chat-main/chat-response-table-chart/chat-response-table-chart.component';
import { SelectButtonModule } from 'primeng/selectbutton';

@NgModule({
    declarations: [
        ChatComponent,
        ChatSidebarComponent,
        ChatQuestionComponent,
        ChatResponseComponent,
        ChatResponseTablesComponent,
        ChatResponseSuggestedQuestionsComponent,
        ChatHeroSuggestedQuestionsComponent,
        ChatDocumentComponent,
        DocumentListSiderbarComponent,
        AceEditorComponent,
        ChatIterationLoaderComponent,
        ChatResponseLoaderComponent,
        EsgFiltersComponent,
        ChatMainComponent,
        DocumentsDialogboxComponent,
        QecDocumentsDialogboxComponent,
        EsgDocumentsDialogComponent,
        HighlightPipe,
        ChatResponseTableChartComponent,
    ],
    exports: [
        ChatSidebarComponent,
    ],
    imports: [
      MarkdownModule.forRoot({
        markedOptions: {
          provide: MARKED_OPTIONS,
          useFactory: () => {
            const renderer = new MarkedRenderer();
            const linkRenderer = renderer.link;

            renderer.link = (href, title, text) => {
              const html = linkRenderer.call(renderer, href, title, text);
              return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
            };

            return {
              renderer: renderer,
              breaks: true
            };
          }
        }
      }),
        CommonModule,
        AutoCompleteModule,
        OverlayPanelModule,
        DialogModule,
        FormsModule,
        InputTextareaModule,
        SplitButtonModule,
        InputTextModule,
        ButtonModule,
        AccordionModule,
        ToastModule,
        EditorModule,
        StyleClassModule,
        ProgressSpinnerModule,
        TooltipModule,
        SidebarModule,
        TableModule,
        ProgressBarModule,
        SharedModule,
        AngularEditorModule,
        TabViewModule,
        MultiSelectModule,
        CheckboxModule,
        DocumentsModule,
        InputSwitchModule,
        CarouselModule,
        SelectButtonModule,
        ChatRoutingModule
    ],
})
export class ChatModule {}
